module.exports = __webpack_public_path__ + "static/hero-cans-en-US-5809e03417d0ea609835bac2ad67d1ea.png";